/* Copyright (c) 2017 Backpack Health LLC */

import React from 'react';
import { FormattedMessage } from 'react-intl';

import ContentFrame from '../../applicationFrame/ContentFrame';
import { ScrollAwareContext, ScrollAwareScroller, ScrollAwareAppNavStep } from '../../components/ScrollAware';
import { AppHeaderScrollableText } from '../../components/appNav/AppHeaderScrollable';
import PreformattedText from '../../components/PreformattedText';
import { Button } from '../../components/buttons/Buttons';
import ContentWrapper from '../../components/ContentWrapper';
import Card, { CardSection } from '../../components/card/Card';

import { useNavigate } from '../../hooks/useNavigate';
import { useActiveProfile, useUserProfile } from '../../hooks/useProfile';
import { useUIState } from '../../hooks/useUIState';
import ProfileModel from '../../../models/ProfileModel';
import RouteNames from '../RouteNames';
import ProfileActions from '../redux/ProfileActions';
import ContentLoader from '../../components/ContentLoader';

const ConfirmDeleteProfile = () => {
  const [currentProfileData] = useActiveProfile();
  const currentProfile = new ProfileModel(currentProfileData.data);
  const [userProfileData] = useUserProfile();
  const mainProfile = new ProfileModel(userProfileData.data);
  const [, navActions] = useNavigate();
  const [uiState, uiActions] = useUIState();
  const isMainProfile = uiState.isActiveProfileMainProfile;
  const [isLoading, setIsLoading] = React.useState(false);

  return (
    <div>
      <ScrollAwareContext>
        <ScrollAwareAppNavStep
          cancel={() => {
            navActions.goBack(RouteNames.profile());
          }}
          color="white"
        />
        <ContentLoader isContentLoaded={!isLoading}>
          <ContentFrame>
            <ScrollAwareScroller>
              <AppHeaderScrollableText
                id="profileDeleteConfirm.title.text"
                values={{ string1: currentProfile.greetingName() }}
              />
              <ContentWrapper>
                  <Card>
                  <CardSection hasBorder={false}>
                    <PreformattedText
                      textClassName="font-subhead font-color-gsDark"
                      text="profileDeleteConfirm.delete.message.text"
                    />
                  </CardSection>
                </Card>

                <Button
                  action="destructive"
                  onClick={() => {
                    if (isLoading) { return; }

                    if (isMainProfile) {
                      navActions.goBackTo(RouteNames.home());
                      uiActions.closeAppMenuSection();
                    } else {
                      setIsLoading(true);
                      ProfileActions.api.deleteDependentProfile(currentProfile.data.id, () => {
                        uiActions.setActiveProfile(mainProfile.data.id);
                        setIsLoading(false);
                        uiActions.closeAppMenuSection();
                        navActions.goBackTo(RouteNames.myBackpack());
                      });
                    }
                  }}
                  size="wide"
                >
                  <FormattedMessage id="profileDeleteConfirm.delete.button.label" />
                </Button>
              </ContentWrapper>
            </ScrollAwareScroller>
          </ContentFrame>
        </ContentLoader>
      </ScrollAwareContext>
    </div>
  );
}

export default ConfirmDeleteProfile;
